import FuelTags from './fuel-tags';
export default FuelTags;